module.exports = __webpack_public_path__ + "fonts/3f0036cea99d49d14f22532b7ec1d571.svg";